import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminHeaderComp from "../subComponent/AdminHeaderComp";
// import AddService from "../subComponent/AddService";
// import DisplayService from "../subComponent/DisplayServices";
import CircularProgress from '@mui/material/CircularProgress';

const columns = [
    { id: 'issue_date', label: 'Created Date', minWidth: 76, sortable: true },
    { id: 'user_name', label: 'User Name', sortable: true },
    { id: 'email', label: 'Email', minWidth: 100, sortable: true },
    { id: 'phone_no', label: 'Phone', minWidth: 100, sortable: true },
    { id: 'amount', label: 'Amount', minWidth: 50, alignItems: 'center', sortable: true },
    { id: 'service_name', label: 'Service Name', minWidth: 100, sortable: true },
    { id: 'plan_months', label: 'Plan Months', minWidth: 50, alignItems: 'center', sortable: true },
    // { id: 'genarate_id', label: 'URL ID', minWidth: 100 },
    { id: 'payment_status', label: 'Payment Status', minWidth: 100, sortable: true },
    { id: 'transaction_id', label: 'Transaction ID', minWidth: 100, sortable: true },
    { id: 'subscribed_on', label: 'Subscribed On', minWidth: 80, sortable: true },
    { id: 'subscribe_expired_on', label: 'Subscribe Expired On', minWidth: 80, sortable: true },
    { id: 'actions', label: 'Actions', minWidth: 100 }
];

const loadingSpace = {
    height: "18rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}

const ClientDetails = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [rows, setRows] = useState([]);
    const [isAllLoading, setIsAllLoading] = useState(false);
    const [sortColumn, setSortColumn] = useState('');
    const [sortDirection, setSortDirection] = useState('asc');

    useEffect(() => {
        if (!localStorage.getItem("invCreator")) {
            navigate("/login-creator");
        }
        handleDisplayClientDetails();
    }, []);

    const handleDisplayClientDetails = async () => {
        setIsAllLoading(true);
        try {
            const response = await fetch('https://apiroutetapxtream.invtechnologies.in/get_all_payment_services', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                const data = await response.json();
                // console.log(data);
                setRows(data.reverse());
            } else {
                throw new Error('Failed to get data');
            }
        } catch (err) {
            console.error('Error getting data:', err);
        } finally {
            setIsAllLoading(false);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleSort = (columnId) => {
        const isAsc = sortColumn === columnId && sortDirection === 'asc';
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortColumn(columnId);

        const sortedData = [...rows].sort((a, b) => {
            if (a[columnId] < b[columnId]) return isAsc ? -1 : 1;
            if (a[columnId] > b[columnId]) return isAsc ? 1 : -1;
            return 0;
        });

        setRows(sortedData);
    };

    return (
        <Box sx={{ backgroundColor: "#0f172a", minHeight:"100vh" }}>
            <AdminHeaderComp />
            <Box p={2} />
            <Paper sx={{ width: '100%', overflow: 'hidden',}}>
                <TableContainer>
                    {
                        isAllLoading ? <Box style={loadingSpace}><CircularProgress /> </Box> :
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
                                            >
                                                {column.sortable ? (
                                                    <TableSortLabel
                                                        active={sortColumn === column.id}
                                                        direction={sortColumn === column.id ? sortDirection : 'asc'}
                                                        onClick={() => handleSort(column.id)}
                                                    >
                                                        {column.label}
                                                    </TableSortLabel>
                                                ) : column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, index) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                                    {columns.map((column) => {
                                                        const value = row[column.id];
                                                        // if (column.id === 'is_subscribed') {
                                                        //     value = value === 1 ? 'Yes' : 'No';
                                                        // } else if (column.id === 'signup_on') {
                                                        //     value = formatDate(value);
                                                        // }
                                                        return (
                                                            <TableCell key={column.id} align={column.align}>
                                                                {column.id === 'actions' ? (
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        onClick={() => window.open(`https://payments.invtechnologies.in/paynow/${row.genarate_id}`, '_blank')}
                                                                    >
                                                                        URL Link
                                                                    </Button>
                                                                ) : (
                                                                    column.format && typeof value === 'number'
                                                                        ? column.format(value)
                                                                        : value || 'N/A'
                                                                )}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                    }
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <Box p={2} />
        </Box>
    )
}
export default ClientDetails;